export default [
  {
    path: '/ai-report',
    component: () => import('./views/Index'),
    name: 'ai_report',
  },
]
